import React from 'react';
import MainLayout from '../components/MainLayout';
import { Link } from 'react-router-dom';
import whoweare from '../assets/images/img/who-we-are.jpg';
import Accordion from 'react-bootstrap/Accordion';
import robotic from '../assets/images/robotic-process.jpg';
import rpausecases from '../assets/images/rpa-use-cases.jpg';

export default function RoboticProcessAutomation() {

  return (
    <>
    <MainLayout>

    <div className='breadcrumb_area'>
    <div className='photo'>
    <img src={whoweare} alt=''/>
      <div className='wrapper'> 
          <div className='container'>
          <div className='row'>
          <div className='col-12'>
          <h1 className='breadcrumb_title'>Robotic Process Automation</h1>
          <ul className="breadcrumb_list">
          <li className="breadcrumb_item"><Link to='/'>Home</Link></li>
          <li className="breadcrumb_item">Robotic Process Automation</li>                 
          </ul>
          </div>
          </div>
          </div>  
      </div>
    </div>
    </div>

    <div className='inner_page_content robotic_process_automation'> 
      <div className='container'>

          <div className='row'>
        
          {/* <div className='col-12'>
              <h2>Corporate Module Functionality </h2>
              
              <p>We specialize in delivering mobile app development services that help businesses create innovative, user-friendly, and high-performance mobile applications. Whether you're looking to develop an app for iOS, Android, or cross-platform, our team of expert developers provides end-to-end mobile app solutions tailored to your business needs.</p>
        
        <h4>Our Mobile App Development Process:</h4>
        
          </div> */}

<div className='col-12 mt-2 mb-4'>

<div className='rba'>


<div><img  src={robotic} alt='' /></div>     

  <div>
  <h2>Robotic Process Automation (RPA)</h2>
  <p>Robotic Process Automation (RPA) uses software robots to automate routine, rule-based tasks in your business processes. This technology enables your team to focus on higher-value work, driving innovation and growth. Today, efficiency and accuracy are more critical than ever. Our Robotic Process Automation (RPA) solutions offer a powerful way to streamline your operations, reduce costs, and increase productivity. Whether you’re looking to automate mundane tasks or complex workflows, we have the expertise and technology to make it happen.</p>

  </div>

  {/* <div><img src={vision2} alt='' /></div> */}
 

</div>

</div>



<div className='col-12'>

<Accordion defaultActiveKey="0">

<Accordion.Item eventKey="0">
  <Accordion.Header>The uses of RPA systems</Accordion.Header>
  <Accordion.Body>

<p>To bring you on this journey, it would be useful to know exactly what Robotic Process Automation is, especially for those that are currently scratching your heads thinking we are talking about the next futuristic blockbuster!</p>

<p>RPA (robotic process automation) is the automation of repetitive and rule-based tasks that are performed by people. And by using RPA, businesses can simplify work and achieve more in less time.  Again you are probably thinking, ‘Yeah, but how can I use that in my business?’ For example, if you are a travel company where you rely on manual processes for repetitive tasks such as managing flight schedule changes, sending out tickets and itineraries to customers or matching supplier invoices – then yes, RPA is technology you will be able to utilize. It will save you money, allow you to scale, improve your processes, and make your employees happy. So it is a win-win all around.</p>

<p>We are experts in our field so can easily assist you in applying RPAs to your business. There are a wide range role that RPAs can help assist your business with Integration: Driving multiple APIs, integrating internal systems and driving MS Office applications</p>

<p>Matching: Matching documents, processing customers’ requirements and de-duping.</p>
<p>Categorization: Categorizing emails, analyzing customer sentiment, and segmenting customers.</p>
<p>Reporting: Collating data, analyzing data, integrating data and producing excel MI documents.</p>
<p>Repetitive: Loading data, cut and pasting tasks, searching the web and enforcing business rules.</p>
<p>Take advantage of our years of experience to see how you can support your business using Robotic Process Automation. We would love to hear from you, so we can help boost your companies’ capabilities.</p>

  </Accordion.Body>
</Accordion.Item>


</Accordion>

</div>


<div className='col-12 mt-3'>

<div className='row'>
    <div className='col-lg-1'></div>
    <div className='col-lg-10'>
    <img className='img-fluid' src={rpausecases} alt=''/>
    </div>
    <div className='col-lg-1'></div>
</div>

</div>

<div className='col-lg-12 mt-4'>
    <h4 className='mb-3'>Build a virtual workforce to automate your manual processes</h4>
    <p>Today RPA is fundamental technology in an overall automation strategy. It acts as the glue between your multiple business systems and performs the manual, repetitive and long-winded tasks for you. Enjoy reduced costs by streamlining your processes and free up your employees to focus on client communication and supporting your customers. With the increase of artificial intelligence there is no reason to not take advantage of the tools available. Human resources can be re-allocated to doing the tasks they specialize in and allowing software bots to focus on automated tasks.</p>
</div>
          </div>

      </div>
    </div>

    </MainLayout>
    </>
  )
}
